import { FieldValues, UseFormRegister } from 'react-hook-form'
import { LabelsForInput } from 'components/LabelsForInputs'
import { TextArea } from 'components/TextArea'

export interface IJustifyGroupTreatmentProps {
    isDone: boolean
    managerReview?: string
    isSimpleTreatment: boolean
    register: UseFormRegister<FieldValues>
    submitManagerReview: () => void
    managersReviewError?: string
    totalNotifications?: number
    onJustificationChange?: (isFilled: boolean, value?: string) => void
    loggedInUserIsResponsible?: boolean
}

export const JustifyGroupTreatment = ({
    managerReview,
    isDone,
    isSimpleTreatment,
    register,
    submitManagerReview,
    managersReviewError,
    totalNotifications = 0,
    onJustificationChange,
    loggedInUserIsResponsible = true
}: IJustifyGroupTreatmentProps) => {
    // Por enquanto, sempre retorna null para visualização inicial
    // A lógica será implementada posteriormente
    if (!isSimpleTreatment) {
        return null
    }

    if (!isDone) {
        return (
            <div
                data-testid="test-justify-group-treatment-container"
                className='px-8 mt-4'
            >
                <LabelsForInput
                    styles={{ titleStyle: "font-semibold text-darkGray font-sm mt-6" }}
                    title="Justificativa da finalização"
                    subtitle="Obrigatório o parecer do responsável para finalizar o tratamento em grupo."
                />
                <TextArea
                    defaultValue={managerReview}
                    name="u_managers_review"
                    register={register}
                    className="max-h-[257px] h-[257px]"
                    placeholder="Digite aqui a justificativa para finalizar este grupo de tratamento"
                    rows={8}
                    disabled={!loggedInUserIsResponsible}
                    onInput={(e) => {
                        const value = (e.target as HTMLTextAreaElement).value
                        const isFilled = value.trim().length > 0
                        onJustificationChange?.(isFilled, value)
                        submitManagerReview()
                    }}
                    error={{
                        message: managersReviewError
                    }}
                />
            </div>
        )
    }

    return (
        <div data-testid="test-justify-group-treatment-done" className="grid px-8 mt-6">
            <span className="text-xs text-darkGray">
                Justificativa da finalização
            </span>
            <span className="text-sm font-semibold text-darkGray">
                {managerReview}
            </span>
        </div>
    )
}
